import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../../../comman/Loader";
import {baseUrl, purchaseProductList, milkType} from "../../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        date : today,
        staff_id : '',
        salary:'',
        upaad: '',
        due_salary : ''
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        staff_id: false,
        salary: false,
        upaad: false,
        due_salary: false,
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();

    useEffect(() => {
        getStaffList();
    }, []);
    
    useEffect(() => {
        if(detail){
            const staffItem = staffList.find((item) => item.id == detail[0].staff_id);
            const staffObject = staffItem ? {value : staffItem.id, label : staffItem.name} : {value : "", label : ""};
            setFormData({
                date: detail[0].date || today,
                staff_id: staffObject,
                salary : detail[0].salary || 0,
                upaad : detail[0].upaad || '',
                due_salary: detail[0].due_salary || 0,
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, staffList]);


    const getStaffList = async (e) => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/labour/staff_list?type=${3}`);
        setStaffList(response.data.data);
        setPopupOpen(false);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            staff_id : !formData.staff_id.value,
            salary : formData.salary === '',
            // due_salary : formData.due_salary === ''
            
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `admin/construction/labour/edit/${detail[0].id}`;
                }else{
                    url = "admin/construction/labour/add";
                }
                console.log(url);
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/admin/construction/labour");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name === "staff_id"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                "salary" : staffList.find((item) => item.id == data.value)?.salary ?? 0
              }));
              
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
              }));
        }
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="staff_id" className="block text-sm font-medium leading-6 text-gray-900">Staff Name</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.staff_id}
                                        name="staff_id"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={staffList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.staff_id && <div className="text-red-500">Please select a staff name.</div>}
                            </div>
                        </div>
                       
                         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                         <div className="sm:col-span-2">
                                <label htmlFor="salary" className="block text-sm font-medium leading-6 text-gray-900">Salary</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="salary"
                                      name="salary"
                                      type="number"
                                      step="0.01"
                                      placeholder='Salary'
                                      value={formData.salary}
                                      readOnly
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.salary ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.salary && <div className="text-red-500">Please enter salary.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="upaad" className="block text-sm font-medium leading-6 text-gray-900">Upaad</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="upaad"
                                      name="upaad"
                                      type="number"
                                      step="0.01"
                                      placeholder='Upaad'
                                      value={formData.upaad}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.upaad ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.upaad && <div className="text-red-500">Please enter upaad.</div>}
                            </div>
                         
                        </div>

                        {/* <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="due_salary" className="block text-sm font-medium leading-6 text-gray-900">Due Salary</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="due_salary"
                                      name="due_salary"
                                      type="number"
                                      step="0.01"
                                      placeholder='Due Salary'
                                      value={formData.due_salary}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.due_salary ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.due_salary && <div className="text-red-500">Please enter due salary.</div>}
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/admin/construction/labour">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }